import { render, staticRenderFns } from "./ExchangeControl.vue?vue&type=template&id=21952b88"
import script from "./ExchangeControl.vue?vue&type=script&lang=js"
export * from "./ExchangeControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports